import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export enum Icons {
  'map-icon',
  'delete-icon-run',
  'key-support',
  'key-support-remove'
}

@Injectable( {
  providedIn: 'root'
} )
export class IconsService {

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) { }

  public registerIcons(): void {
    this.loadIcons( Object.keys( Icons ), '../assets/svg' );
  }

  private loadIcons( iconKeys: string[], iconUrl: string ): void {
    iconKeys.forEach( key => {
      this.matIconRegistry.addSvgIcon( key, this.domSanitizer.bypassSecurityTrustResourceUrl( `${ iconUrl }/${ key }.svg` ) );
    } );
  }
}
